import { AirlineCode } from "./AirlineCode.enum";

export enum UnflownAirwayStatus {
  OPEN = "open",
  USED = "used",
  EXPIRED = "expired",
  REFUNDED = "refunded",
  REFUND_REQUESTED = "refund_requested",
}

export enum UnflownAirwayRefundStatus {
  REQUESTED = "requested",
  APPROVED = "approved",
  DENIED = "denied",
  REFUNDED = "refunded",
}

export enum UnflownAirwayImportStatus {
  VALID = "valid",
  NOT_FOUND = "not_found",
  DUPLICATED = "duplicated",
  ALREADY_EXISTS = "already_exists",
}

export type UnflownAirwayOrder = {
  uuid: string;
  tracker: string;
  orderId: string;
  orderNumber: number;
};

export type UnflownAirway = {
  uuid: string;
  passengersTravelersId: string;
  value: number;
  status: UnflownAirwayStatus;
  originalAirwayOrder: UnflownAirwayOrder;
  newAirwayOrder: UnflownAirwayOrder | null;
  ticket: string;
  airline: AirlineCode;
  changeTax: number | null;
  issueDate: Date;
  expiredAt: Date;
  passengerName: string | null;
  refundRequestedAt: Date | null;
  refundStatus: UnflownAirwayRefundStatus;
  refundRequesterId: string | null;
  customer: {
    uuid: string;
    companyName: string;
    tradingName: string;
  } | null;
};

export type UnflownAirwayImportPreviewItem = {
  ticket: string;
  tracker: string;
  creditValue: number;
  issueDate: string;
  expiredAt: string;
  passengerUuid: string | null;
  airwayOrderUuid: string | null;
  status: UnflownAirwayImportStatus;
  message: string;
  existing: {
    uuid: string;
    creditValue: number;
    expiredAt: string;
    status: string;
  } | null;
};

export type UnflownAirwayImportSummary = {
  total: number;
  valid: number;
  notFound: number;
  alreadyExists: number;
  duplicated: number;
};

export type UnflownAirwayImportPreview = {
  data: UnflownAirwayImportPreviewItem[];
  summary: UnflownAirwayImportSummary;
};

export type UnflownAirwayImportConfirmRecord = {
  ticket: string;
  passengerUuid: string;
  airwayOrderUuid: string;
  creditValue: number;
  expiredAt: string;
  existingUnflownUuid: string | null;
};

export type UnflownAirwayImportConfirmResult = {
  message: string;
  created: number;
  updated: number;
};
